import React, { useState, useEffect } from 'react';
import './loader.css';

const BAR_COUNT = 13;

const Loader = ({ label = 'Processing', onDone }) => {
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsFinished(true), 2200);
    return () => clearTimeout(timer);
  }, []);

  const handleOkClick = (e) => {
    if (e) e.preventDefault();
    if (onDone) onDone();
  };

  const successLabel = label.replace(/ing\b/i, 'ed');

  return (
    <div className="pif-loader-overlay">
      <div className="pif-loader-card">
        <p className="pif-brand-title">Properties In Finite</p>
        <div className="pif-brand-divider" />

        {!isFinished ? (
          <>
            <div className="pif-bar-row" aria-hidden="true">
              {Array.from({ length: BAR_COUNT }, (_, i) => (
                <span key={i} className="pif-bar" style={{ '--i': i }} />
              ))}
            </div>
            <div className="pif-status-section">
              <span className="pif-status-label">{label}</span>
              <div className="pif-dots">
                <span /><span /><span />
              </div>
            </div>
          </>
        ) : (
          <div className="pif-success-content">
            <div className="pif-success-check" aria-hidden="true">✓</div>
            <div className="pif-success-text">{successLabel} Successfully!</div>
            <button type="button" className="pif-success-btn" onClick={handleOkClick}>
              OK
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Loader;
